import { useFormikContext } from 'formik'
import { useState } from 'react'

export function AccordionItem ({ title, children, hasErrors }) {
  return children
}

export function Accordion({ children, className, accordionId, activeAccordionId, setActiveAccordionId }) {
  if (!Array.isArray(children)) {
    children = [children];
  }

  return (
    <div className={'accordion ' + className}>
      {children.map((child, index) => {
        if (child == undefined) return null;

        const isAccordionActive = activeAccordionId === `${accordionId}-${index}`;

        return (
          <div key={index} className={'accordion-item'}>
            <div
              className={
                'accordion-header' +
                (isAccordionActive ? ' active' : '') +
                (child.props.hasErrors ? ' hasErrors' : '')
              }
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setActiveAccordionId(isAccordionActive ? null : `${accordionId}-${index}`);
                global.window.document.querySelector('.' + className)?.scrollIntoView({ behavior: 'instant' });
              }}
            >
              {child.props.title}
            </div>
            {isAccordionActive && <div className={'accordion-body'}>{child}</div>}
          </div>
        );
      })}
    </div>
  );
}